"use client";

import React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const facilitiesList = ["Licensed & Insured professionals for your peace of mind.", "Same-day scheduling available for urgent requirements.", "Comprehensive reports delivered within 24 hours.", "Serving Miami-Dade, Broward, and the Florida Keys."];
export default function AboutAndFacilities() {
  const {
    ref: topRef,
    isVisible: isTopVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: bottomRef,
    isVisible: isBottomVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="250035" id="trustcards" className="w-full flex flex-col bg-background text-foreground">
      {}
      <div className="w-full bg-secondary text-secondary-foreground py-16 md:py-24">
        <div ref={topRef} className={`max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-12 items-center transition-all duration-1000 ${isTopVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          {}
          <div className="border-2 border-primary p-8 md:p-12 rounded-md shadow-2xl bg-secondary/50 backdrop-blur-sm">
            <h2 className="font-default text-3xl md:text-4xl font-bold text-primary mb-8 text-center lg:text-left">
              Local South Florida Inspection Experience
            </h2>
            <div className="space-y-6 text-base md:text-lg leading-relaxed text-secondary-foreground/90">
              <p>
                Trusted Inspections is a family-owned South Florida home inspection company. We help buyers, sellers, homeowners, realtors, and insurance clients understand property condition with clear, photo-rich reports and practical communication.
              </p>
              <p>
                We specialize in full home inspections, wind mitigation, 4-point inspections, condo inspections, mold testing, thermal imaging, and sewer camera inspections across Trusted Inspections serves South Florida, including Miami-Dade, Broward, the Florida Keys, and premium residential markets such as Coral Gables, South Miami, Palmetto Bay, Pinecrest, Miami Beach, and Fort Lauderdale.
              </p>
              <div className="pt-4 flex justify-center lg:justify-start">
                <Link to="#" className="inline-flex items-center justify-center px-8 py-4 bg-primary text-primary-foreground font-bold rounded-md shadow-lg hover:bg-primary/90 transition-colors duration-300">
                  Schedule Your Inspection
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="mx-auto lg:mx-0 w-full max-w-md">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/inspector_professional.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/inspector_professional.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/inspector_professional.png-wvc-sizes" alt="Professional Home Inspector" className="w-full h-auto object-cover rounded-lg shadow-xl border border-border" loading="lazy" />
          </div>
        </div>
      </div>

      {}
      <div className="w-full bg-background py-16 md:py-24">
        <div ref={bottomRef} className={`max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 items-center transition-all duration-1000 delay-200 ${isBottomVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          {}
          <div className="order-2 lg:order-1">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/inspection_detail_1.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/inspection_detail_1.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/inspection_detail_1.png-wvc-sizes" alt="Detailed Property Inspection" className="w-full aspect-[4/3] object-cover rounded-lg shadow-md border border-border" loading="lazy" />
          </div>

          {}
          <div className="order-1 lg:order-2 flex flex-col justify-center">
            <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground mb-10 text-center">
              Why Choose Trusted Inspections
            </h2>
            <ul className="space-y-6">
              {facilitiesList.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary flex items-center justify-center text-primary-foreground mt-1 shadow-sm">
                    <ChevronRight className="w-4 h-4" />
                  </div>
                  <span className="text-foreground/80 text-lg leading-snug font-default">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {}
          <div className="order-3 lg:order-3">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/inspection_detail_2.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/inspection_detail_2.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/inspection_detail_2.png-wvc-sizes" alt="Modern Inspection Technology" className="w-full aspect-[4/3] object-cover rounded-lg shadow-md border border-border" loading="lazy" />
          </div>
        </div>
      </div>
    </section>;
}